<template>
  <div :class="`${isCard ? 'card-body' : ''} px-0`">
    <table class="table">
      <tbody>
        <tr
          class="shadow-sm"
          v-for="(data, index) in getInfoColumns()"
          :key="index"
        >
          <td
            :style="{
              ...getBackgroundStyle(infoData[data.prop]),
              wordBreak: 'auto',
              textAlign: 'justify',
            }"
          >
            <h6 class="mb-1">
              <strong>{{ data.label }}:</strong>
            </h6>
            <span v-if="validateIsset(infoData[data.prop])" class="mt-2">
              <template v-if="data.colors">
                <div :style="getBackgroundStyle(infoData[data.prop])">
                  {{ infoData[data.prop].color }}
                </div>
              </template>
              <template v-else-if="data.image">
                <image-with-zoom
                  :urlFile="infoData[data.prop]"
                  :diskName="infoData.disk"
                />
              </template>
              <template v-else>
                {{ infoData[data.prop] }}
              </template>
            </span>
            <el-tag
              v-else
              type="warning"
              :effect="infoData.effectTags"
              class="mt-2"
              >{{ $t('common_words.no_assignment') }}</el-tag
            >
          </td>
        </tr>
        <slot name="addColumn"></slot>
        <tr class="shadow-sm" v-if="showBusinesses">
          <td-info-tag
            :data="infoData.businesses"
            :tdLabel="`${$t('common_words.associated_companies')}:`"
            :fieldTag="labelTags.businesses"
            :effect="infoData.effectTags"
          />
        </tr>
        <tr class="shadow-sm" v-if="showModules">
          <td-info-tag
            :data="infoData.modules"
            :tdLabel="`${$t('common_words.modules')}:`"
            :fieldTag="labelTags.modules"
            :effect="infoData.effectTags"
          />
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import { isset } from 'src/util/Util.js';
import ImageWithZoom from '../ImageWithZoom.vue';
import TdInfoTag from './TdInfoTag.vue';

export default {
  name: 'info-table',
  components: {
    [ImageWithZoom.name]: ImageWithZoom,
    [TdInfoTag.name]: TdInfoTag,
  },
  props: {
    labelTags: {
      type: Object,
      default: () => ({
        businesses: 'name',
        modules: 'name',
      }),
    },
    infoColumns: {
      type: Array,
      default: () => [],
    },
    infoData: {
      type: Object,
      default: () => ({}),
    },
    showBusinesses: {
      type: Boolean,
      default: false,
    },
    showModules: {
      type: Boolean,
      default: false,
    },
    isCard: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    validateIsset(data) {
      return isset(data);
    },
    getInfoColumns() {
      return this.infoColumns.filter(
        (column) => column.toShow || typeof column.toShow == 'undefined'
      );
    },
    getBackgroundStyle(data) {
      let style = {};
      if (data && data.color && data.color_text) {
        style.backgroundColor = data.color;
        style.color = data.color_text;
      }
      return style;
    },
  },
};
</script>
